module.exports = __webpack_public_path__ + "static/nurseio-078247ee6890af1b370569f546a12f41.jpeg";